import globalAxios from "axios";
import {Cookie} from "components/src/utils/Cookie";

function generateCookie()
{
    const token = crypto.randomUUID();

    Cookie.setCookie("XSRF-TOKEN", token, null, true, "Strict");

    return token;
}

function getCookie() {
    return Cookie.getCookie("XSRF-TOKEN") ?? ""
}

/**
 * Returns the token, and creates the cookie first if there is none. The cookie can disappear while a page is open:
 * every application on the same host shares it, because cookies do not tell ports apart, and a back-end deletes it
 * when a user signs in or out. Signing out of the admin console deletes the cookie of an open portal page as well,
 * and the next POST of that page would be rejected.
 */
function ensureCookie() {
    return getCookie() || generateCookie();
}

// Ensure a token exists from the moment this module is first imported. That is not enough on its own, because the
// cookie can be deleted later; the interceptor below and the forms, which call ensureCookie(), create it again.
ensureCookie();

// Before every request of the API clients, which use the global axios instance. Axios reads the cookie into the
// X-XSRF-TOKEN header after the request interceptors have run. Synchronous, so axios keeps dispatching a request in
// the same tick, as it does without interceptors, instead of through a promise chain.
globalAxios.interceptors.request.use(config => {
    ensureCookie();
    return config;
}, undefined, {synchronous: true});

export const XSRF = () => {
    return
}

XSRF.ensureCookie = ensureCookie;
